import { Box, Stack, Typography, Paper } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';

interface StatsCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  icon?: React.ReactNode;
  trend?: number;
  color?: string;
}

export const StatsCard = ({ 
  title, 
  value, 
  subtitle, 
  icon,
  trend,
  color = '#0099CC'
}: StatsCardProps) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        borderRadius: '16px',
        border: '1px solid #E5E7EB',
        backgroundColor: '#FFFFFF',
        flex: 1,
        minWidth: 200,
      }}
    >
      <Stack spacing={1}>
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
          <Typography 
            variant="body2" 
            sx={{ 
              color: '#6B7280',
              fontWeight: 500,
              textTransform: 'uppercase',
              fontSize: '0.75rem',
              letterSpacing: '0.05em',
            }}
          >
            {title}
          </Typography>
          {icon && (
            <Box 
              sx={{ 
                p: 1, 
                borderRadius: '8px', 
                backgroundColor: `${color}15`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {icon}
            </Box>
          )}
        </Stack>
        
        <Typography 
          variant="h4" 
          sx={{ 
            fontWeight: 700, 
            color: '#2C3E50',
            fontSize: '2rem',
          }}
        >
          {value}
        </Typography>

        {(subtitle || trend !== undefined) && (
          <Stack direction="row" alignItems="center" spacing={1}>
            {trend !== undefined && (
              <Stack 
                direction="row" 
                alignItems="center" 
                sx={{ 
                  color: trend >= 0 ? '#10B981' : '#EF4444',
                  fontSize: '0.875rem',
                }}
              >
                {trend >= 0 ? (
                  <TrendingUpIcon sx={{ fontSize: 16, mr: 0.5 }} />
                ) : (
                  <TrendingDownIcon sx={{ fontSize: 16, mr: 0.5 }} />
                )}
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  {Math.abs(trend)}%
                </Typography>
              </Stack>
            )}
            {subtitle && (
              <Typography variant="body2" sx={{ color: '#9CA3AF' }}>
                {subtitle}
              </Typography>
            )}
          </Stack>
        )}
      </Stack>
    </Paper>
  );
};
